import React, { useEffect } from 'react';
import { HereYourPlans } from '@features/onboarding/components/7-finish/HereYourPlans';

export const CoverageReassurance = ({ isChangePlan } : { isChangePlan?: boolean }) => {
  useEffect(() => {
    console.log('CoverageReassurance')
  }, [])
  return (
    <HereYourPlans
      isChangePlan={isChangePlan}
    />
  );
};
